import React from 'react';
import { Field } from 'formik';

const FormSelect = ({ name, options, ...props }) => {
  return (
    <Field as="select" name={name} {...props} className='input-edit'>
      <option value="">Select an option</option>
      {options.map(option => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </Field>
  );
};

export default FormSelect;
